export const BACKGROUND_WIDTH = 4096;
export const BACKGROUND_HEIGHT = 1097;
export const BACKGROUND_RANGE_ANIMATION = 0.8;
export const MONEYS_RANGE = 0.2;
export const MAX_ITEMS_INTERVAL = 2500;
export const MAX_ITEMS_INTERVAL_STEP = 200;
export const ANIMATION_SPEED = [25, 27, 29, 31, 33, 35];
export const JUMP_DELAY = 1000;
export const FAIL_DELAY = 5000;